export default __webpack_public_path__ + "static/media/miraSD.ee98922e.png";